import { configureStore } from '@reduxjs/toolkit';
import commonSettingsReducer from './reducers/common-settings';
import otherSettingsReducer from './reducers/other-settings';
import categorySettingsReducer from './reducers/category-settings';
import holidaySettingsReducer from './reducers/holiday-settings';
import productSettingsReducer from './reducers/product-settings';
import rescheduleSettingsReducer from './reducers/reschedule-settings';
import pickupLocationSettingsReducer from './reducers/pickup-location-settings';
import rushSurchargeSettingsReducer from './reducers/rush-surcharge-settings';

const store = configureStore({
  reducer: {
    commonSettings: commonSettingsReducer,
    otherSettings: otherSettingsReducer,
    categorySettings: categorySettingsReducer,
    holidaySettings: holidaySettingsReducer,
    productSettings: productSettingsReducer,
    rescheduleSettings: rescheduleSettingsReducer,
    pickupLocationSettings: pickupLocationSettingsReducer,
    rushSurchargeSettings: rushSurchargeSettingsReducer,
  }
});

export default store;